import { render } from "./PropsEdit.vue?vue&type=template&id=1e45452f"
import script from "./PropsEdit.vue?vue&type=script&lang=js"
export * from "./PropsEdit.vue?vue&type=script&lang=js"
script.render = render

export default script